import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import AppInput from "../../../../components/AppInput";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

function ViewBunkerFuelChangeoverCom() {
  const { fuel_id } = useParams();
  const [form, setForm] = useState({
    changeOverCompletion: moment(),
    shipPositionCompletion: "",
    lowSulphurQtyAfter: "",
    ecaEntry: moment(),
    ecaExit: moment(),
    changeOverToHighSulphur: moment(),
    shipPositionHighSulphur: "",
    lowSulphurQtyBefore: "",
    remarks: "",
    chiefEngSign: "",
  });
  const [submitStatus, setSubmitStatus] = useState(false);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const VIEW_FUEL_CHARGEOVER_DETAILS = async () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("sulphur_record_id", atob(fuel_id));

    try {
      const response = await post(ApiURL?.view_bunker_fuel_chargerover_fcr_com, FORM_DATA);

      if (response?.status) {
        const data = response?.sulphur_record_three;

        setSubmitStatus(!data?.submit_status);
        // set_Soft_Dlt(data?.soft_delete);

        const mappedData = {
          changeOverCompletion: data?.date_and_time_completion
            ? moment(data.date_and_time_completion)
            : moment(),
          shipPositionCompletion: data?.ship_position || "",
          lowSulphurQtyAfter: data?.low_sulphur_quality_completion || "",
          ecaEntry: data?.date_and_time_entry_eca ? moment(data.date_and_time_entry_eca) : moment(),
          ecaExit: data?.date_and_time_exit_eca ? moment(data.date_and_time_exit_eca) : moment(),
          changeOverToHighSulphur: data?.date_and_time_changeover_high_sulphur
            ? moment(data.date_and_time_changeover_high_sulphur)
            : moment(),
          shipPositionHighSulphur: data?.ship_position_high_sulphur || "",
          lowSulphurQtyBefore: data?.low_sulphur_quality_start || "",
          remarks: data?.remarks || "",
          chiefEngSign: data?.chief_eng_name_sign || "",
        };

        setForm(mappedData);
      } else {
        console.error("Failed to fetch bunker delivery details:", response);
      }
    } catch (error) {
      console.error("Error in VIEW_FUEL_CHARGEOVER_DETAILS:", error);
    }
  };

  useEffect(() => {
    VIEW_FUEL_CHARGEOVER_DETAILS();
  }, []);

  return (
    <>
      <div className="white-container">
        <h3>View Fuel Changeover Record</h3>
        <br />

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Completion (Low Sulphur)</label>
              <DatePicker
                showTime
                value={form.changeOverCompletion}
                onChange={(date) => handleChange("changeOverCompletion", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (Completion)"
              value={form.shipPositionCompletion}
              onChange={(e) => handleChange("shipPositionCompletion", e.target.value)}
              disabled={submitStatus}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Completion (Tank ID/m3)"
              value={form.lowSulphurQtyAfter}
              onChange={(e) => handleChange("lowSulphurQtyAfter", e.target.value)}
              disabled={submitStatus}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Entry into ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaEntry}
                onChange={(date) => handleChange("ecaEntry", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Exit from ECA-Sox</label>
              <DatePicker
                showTime
                value={form.ecaExit}
                onChange={(date) => handleChange("ecaExit", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time of Changeover to High Sulphur</label>
              <DatePicker
                showTime
                value={form.changeOverToHighSulphur}
                onChange={(date) => handleChange("changeOverToHighSulphur", date)}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm:ss"
                disabled={submitStatus}
              />
            </div>
          </div>
          <div className="col-6">
            <AppInput
              label="Ship's Position (High Sulphur Start)"
              value={form.shipPositionHighSulphur}
              onChange={(e) => handleChange("shipPositionHighSulphur", e.target.value)}
              disabled={submitStatus}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Low Sulphur Quantity at Start (Tank ID/m3)"
              value={form.lowSulphurQtyBefore}
              onChange={(e) => handleChange("lowSulphurQtyBefore", e.target.value)}
              disabled={submitStatus}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <AppInput
              label="Remarks"
              value={form.remarks}
              onChange={(e) => handleChange("remarks", e.target.value)}
              disabled={submitStatus}
            />
          </div>
          <div className="col-6">
            <AppInput
              label="Chief Eng. Name & Digital Signature"
              value={form.chiefEngSign}
              onChange={(e) => handleChange("chiefEngSign", e.target.value)}
              disabled={submitStatus}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewBunkerFuelChangeoverCom;
